<template>
<div class="chapter">
<div class="inner_page">
<p class="quote"><a id="page_vii">… on the one hand, living beings (or substances), and on the other, apparatuses in which living beings are incessantly captured.</a></p><a id="page_vii">
<blockquote class="quoter">Giorgio Agamben, “What Is an Apparatus?”</blockquote>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Fm01.vue?4f1b1a3c